import React, { useEffect, useState } from "react";
import * as S from "./styles";
import { IAttachment } from "interfaces/Attachments";
import AddressIcon from "assets/category-icon.svg";
import { useReport } from "contexts/ReportContext";

export function EstablishmentReportModal() {
  const { report } = useReport();

  const [externalListPic, setExternalListPic] = useState<IAttachment[]>([]);

  useEffect(() => {
    let externalList: IAttachment[] = [];
    let internalDamageList: IAttachment[] = [];
    let internalList: IAttachment[] = [];
    report?.attachments?.forEach((att: IAttachment) => {
      switch (att.category) {
        case "external":
          externalList.push(att);
          break;
        case "internal":
          internalList.push(att);
          break;
        case "internalDamage":
          internalDamageList.push(att);
          break;
        case "owner":
          externalList.push(att);
          break;
        default:
          break;
      }
    });
    setExternalListPic(externalList);
  }, [report]);
  return (
    <S.MoreDetailsContent>
      <S.ReportContent>
        <S.VehicleInformation>
          <S.InfoContainer>
            {externalListPic.length === 0 ? (
              <S.WaitingTitle>
                Realizando procura do estabelecimento...
              </S.WaitingTitle>
            ) : (
              <S.FoundTitle>Estabelecimento encontrado</S.FoundTitle>
            )}
            <S.Information>
              <span>
                <h4>Data de início</h4>
                <p>
                  {report?.startTime
                    ? new Date(report?.startTime).toLocaleDateString("pt-BR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })
                    : "-"}
                </p>
              </span>
              <span>
                <h4>Deslocação</h4>
                <p>
                  {report?.travelTime
                    ? new Date(report?.travelTime).toLocaleTimeString("pt-BR")
                    : "-"}
                </p>
              </span>
              <span>
                <h4>Data de finalização</h4>
                <p>
                  {report?.endTime
                    ? new Date(report?.endTime).toLocaleDateString("pt-BR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })
                    : "-"}
                </p>
              </span>
              <span>
                <h4>Tempo adicional</h4>
                <p>
                  {report?.additionalTime
                    ? new Date(report?.additionalTime).toLocaleTimeString(
                        "pt-BR"
                      )
                    : "-"}
                </p>
              </span>
              <span>
                <h4>Tipo</h4>
                <p>{report?.type === 1 ? "Estabelecimento" : "Veículo"}</p>
              </span>
              <span>
                <h4>Tempo total</h4>
                <p>
                  {report?.totalTime
                    ? new Date(report?.totalTime).toLocaleTimeString("pt-BR")
                    : "-"}
                </p>
              </span>
              <span>
                <h4>Serviço</h4>
                <p>-</p>
              </span>
            </S.Information>
            <S.AddressInfo>
              <h3>
                <img src={AddressIcon} alt="img" /> Endereço{" "}
              </h3>
              <h4>Endereço de origem</h4>
              <p>
                {
                  report?.occurrence?.occurrencesSuperficialAddresses
                    .superficialAddress?.street
                }
                ,{" "}
                {
                  report?.occurrence?.occurrencesSuperficialAddresses
                    .superficialAddress?.number
                }{" "}
                -{" "}
                {
                  report?.occurrence?.occurrencesSuperficialAddresses
                    .superficialAddress?.city
                }{" "}
                -{" "}
                {
                  report?.occurrence?.occurrencesSuperficialAddresses
                    .superficialAddress?.uf
                }
              </p>
            </S.AddressInfo>
          </S.InfoContainer>
        </S.VehicleInformation>
      </S.ReportContent>
    </S.MoreDetailsContent>
  );
}
